export function togglePlayerButton(button, isPaused) {
    let playIcon = button.querySelector(".play-icon");
    let stopIcon = button.querySelector(".stop-icon");

    if (playIcon && stopIcon) {
        if (isPaused) {
            playIcon.style.display = "block"; // Mostra play
            stopIcon.style.display = "none"; // Nasconde stop
        } else {
            playIcon.style.display = "none"; // Nasconde play
            stopIcon.style.display = "block"; // Mostra stop
        }
    }
}
